export function getRepoIssuesQueryPath({owner, repo, query}: {owner: string; repo: string; query: string}) {
  const params = new URLSearchParams({q: query})
  return `/${owner}/${repo}/issues?${params.toString()}`
}
